import React from "react";
import { NavLink } from "react-router-dom";
import withRouter from "../../Utils/withRouter";

const EmailNotFound = () => {


  return (
    <>
      <div className="auth-page-wrapper pt-5 ">

        <div className="auth-one-bg-position auth-one-bg" id="auth-particles">
          <div className="bg-overlay "></div>

          <div className="shape">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              version="1.1"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              viewBox="0 0 1440 120"
            >
              <path d="M 0,36 C 144,53.6 432,123.2 720,124 C 1008,124.8 1296,56.8 1440,40L1440 140L0 140z"></path>
            </svg>
          </div>
        </div>
      </div>

      <div className="auth-page-content">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="text-center mt-sm-5 mb-4 text-white">
                <div className="d-inline-block auth-logo">
                </div>
                <p className="mt-3 fs-15 fw-bolder"></p>
              </div>
            </div>
          </div>


          <div className="row justify-content-center">
            <div className="col-md-8 col-lg-6 col-xl-5">
              <div className="card mt-4">
                <div className="card-body p-4 text-center">
                  <div className="avatar-lg mx-auto mt-2">
                    <div className="avatar-title bg-light text-warning display-3 rounded-circle">
                      <i className="ri-questionnaire-fill" />
                    </div>
                  </div>
                  <div className="mt-4 pt-2">
                    <h4>Oops !</h4>
                    <p className="text-muted mx-4">Your account does not have any registered email, please connect with your Reporting Manager or Administrator.</p>
                    <div className="mt-4">
                      <NavLink to={'/'} className="btn btn-secondary w-100">Back to Login</NavLink>
                    </div>
                  </div>
                </div>
                {/* end card body */}
              </div>
              {/* end card */}
            </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default withRouter(EmailNotFound);